<template>
	<v-container>
		<v-row>
			<v-col cols="12" md="6" lg="4">
				<v-card outlined>
					<v-card-title>
						<span>Контрагенты</span>
						<v-spacer />
						<create-client-modal />
					</v-card-title>
					<v-data-table
							:headers="headers"
							:items="clients.data"
							:loading="loading"
							:server-items-length="clients.meta.total"
							loading-text="Загрузка..."
							disable-sort
							@update:page="fetchClients($event)"
							@update:items-per-page="fetchClients(1, $event)"
					>
						<template #item.name="{ item: client }">
							<router-link :to="`/clients/${client.id}`">
								{{ client.name }}
							</router-link>
						</template>
					</v-data-table>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import CreateClientModal from '@/components/clients/create-modal';
	const HEADERS = [
		{ text: 'Название', value: 'name' },
	];

	export default {
		name: 'ClientsIndex',
		components: { CreateClientModal },
		data: () => ({
			loading: false,
			clients: {
				data: [],
				meta: {
					total: 0,
					current_page: 1,
					per_page: 10,
				},
			},
		}),
		computed: {
			headers() {
				return HEADERS;
			},
		},
		mounted() {
			this.fetchClients();
		},
		methods: {
			async fetchClients(page = 1, limit = null) {
				if (this.loading) {
					return;
				}
				this.loading = true;
				limit = limit ? limit : this.clients.meta.per_page;
				try {
					const response = await this.$http.get('/api/v1/clients', {
						params: {
							page,
							limit,
						},
					});

					this.clients = response.data;
				} catch (e) {
					this.$notify.error(e.message);
				} finally {
					this.loading = false;
				}
			},
			openClient(client) {
				this.$router.push({
					name: 'Clients Show',
					params: {
						id: client.id,
					},
				})
			},
		},
	};
</script>

<style scoped>

</style>
